import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'

import { createQuest } from '../actions/quest'

import { fieldRequired } from '../utils/messages'

class QuestsAddContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      name: '',
      errorsExist: false
    }
    this.handleNameChangeBound = this.handleNameChange.bind(this)
    this.onCreateQuestClickBound = this.onCreateQuestClick.bind(this)
    this.checkForSubmitBound = this.checkForSubmit.bind(this)
  }

  render() {
    return (
      <div className="row questadd">
        <div className="form-group">
          <label className="control-label left" htmlFor="activity_name">
            <FormattedMessage
              id={'QuestsAdd.QuestTitle'}
              defaultMessage={'Quest Title'}
            />
          </label>
          <div className="right">
            <input
              className="form-control"
              id="activity_name"
              name="activity_name"
              type="text"
              onChange={this.handleNameChangeBound}
              onKeyPress={this.checkForSubmitBound}
            />
            {this.state.errorsExist && !this.state.name && (
              <label
                id="quest_name-error"
                className="error"
                htmlFor="quest_name"
              >
                {fieldRequired}
              </label>
            )}
            <div style={{ marginTop: '30px' }}>
              {!this.props.isFetching ? (
                <div
                  className="button add btn-primary"
                  onClick={this.onCreateQuestClickBound}
                >
                  <FormattedMessage
                    id={'QuestsAdd.CreateQuest'}
                    defaultMessage={'Create Quest'}
                  />
                </div>
              ) : (
                <div className="loading"></div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  checkForSubmit(e) {
    if (e.which === 13 || e.keyCode === 13) {
      this.onCreateQuestClick()
    }
  }

  handleNameChange(e) {
    this.setState({ name: e.target.value })
  }

  onCreateQuestClick() {
    if (!this.state.name) {
      this.setState({ errorsExist: true })
    } else {
      const { dispatch } = this.props
      dispatch(createQuest(this.state.name.trim(), this.context.intl))
    }
  }
}

QuestsAddContainer.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired
}

QuestsAddContainer.contextTypes = {
  intl: PropTypes.object.isRequired
}

export const mapStateToProps = state => ({
  isFetching: state.quest.isFetching
})

export default connect(mapStateToProps)(QuestsAddContainer)
export { QuestsAddContainer as QuestsAddContainerDisconnected } // Pure component for testing



// WEBPACK FOOTER //
// ./src/containers/QuestsAdd.js